import Actions from '../../action'
const initialState = {
    isLoading: false,
    ordersList: [],
    invoiceCount: undefined,
    error: false,
    mailLoading: false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.ORDERS_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.ORDERS_LIST_SUCCESS: {

            return {
                ...state,
                isLoading: false,
                ordersList: action.data.response,
                invoiceCount: action.data.invoiceCount,
                error: false
            };
        }
        case Actions.ORDERS_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }

        case Actions.SEND_TO_MAIL: {
            return {
                ...state,
                mailLoading: true,
            };
        }
        case Actions.SEND_TO_MAIL_SUCCESS: {

            return {
                ...state,
                mailLoading: false,
                error: false
            };
        }
        case Actions.SEND_TO_MAIL_FAILURE: {
            return {
                ...state,
                mailLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};
